import { Typography } from "@povio/ui";
import Link from "next/link";

import { CryptoIcon } from "@/assets/icons/general/wallet/CryptoIcon";
import { DogcoinIcon } from "@/assets/icons/general/wallet/DogcoinIcon";
import { RouteConfig } from "@/config/route.config";
import { NumberUtils } from "@/util/number.utils";

interface HeaderCryptoHoldingsProps {
  totalCryptoAmount: number;
  showClaimReward?: boolean;
}

export const HeaderCryptoHoldings = ({ totalCryptoAmount, showClaimReward = false }: HeaderCryptoHoldingsProps) => {
  return (
    <div
      className="flex flex-row items-center gap-px border-elevation-outline-default-1 border-r pr-2"
      role="region"
      aria-label="Crypto holdings summary"
    >
      {/* Crypto Holdings card */}
      <div
        className="flex h-[54px] flex-col justify-center gap-0-5 rounded-s bg-elevation-fill-default-2 px-3 pt-2 pb-1"
        aria-label="Crypto Holdings"
      >
        <div className="flex flex-row items-center gap-2">
          <CryptoIcon
            className="h-4 w-4 shrink-0"
            aria-hidden
          />
          <div className="flex flex-row items-center gap-1">
            {showClaimReward ? (
              <Link
                href={RouteConfig.MyWallet}
                className="text-text-default-1 outline-none ring-offset-2 hover:underline focus-visible:ring-2 focus-visible:ring-primary"
              >
                <Typography
                  size="title-4"
                  variant="prominent-1"
                  className="text-text-default-1"
                >
                  Claim reward
                </Typography>
              </Link>
            ) : totalCryptoAmount > 0 ? (
              <>
                <Typography
                  size="title-4"
                  variant="prominent-1"
                  className="text-text-default-1"
                >
                  {NumberUtils.formatAsUSCurrency(totalCryptoAmount, {
                    maximumDecimalPlaces: 2,
                  })}
                </Typography>
                <div className="flex flex-col items-baseline">
                  <Typography
                    size="label-2"
                    variant="default"
                    className="text-text-default-3"
                  >
                    USD
                  </Typography>
                </div>
              </>
            ) : (
              <Typography
                size="title-4"
                variant="prominent-1"
                className="text-text-default-3"
              >
                Coming soon!
              </Typography>
            )}
          </div>
        </div>
        <Typography
          size="label-2"
          variant="default"
          className="text-text-default-3"
        >
          Crypto Holdings
        </Typography>
      </div>

      {/* LossDog Coin card */}
      <div
        className="flex h-[54px] flex-col justify-center gap-0-5 rounded-s bg-elevation-fill-default-2 px-3 pt-2 pb-1"
        aria-label="Lossdog Coin"
      >
        <div className="flex flex-row items-center gap-2">
          <DogcoinIcon
            className="h-4 w-4 shrink-0"
            aria-hidden
          />
          <div className="flex flex-row items-center gap-1">
            <Typography
              size="title-4"
              variant="prominent-1"
              className="text-text-default-3"
            >
              Coming soon!
            </Typography>
          </div>
        </div>
        <Typography
          size="label-2"
          variant="prominent-1"
          className="text-text-default-3"
        >
          Lossdog Coin
        </Typography>
      </div>
    </div>
  );
};
